<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner :slider="slider"/>
    <FuncTwoCard  :cardData="cardData" title="直播短视频"/>
    <LiveEffectCard />
    <SceneCard />
    <FuncLibrary />
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncTwoCard from '../widgets/func-two-card'
import FuncLibrary from './widgets/func-library'
import LiveEffectCard from './widgets/live-effect-card'
import SceneCard from './widgets/scene-card'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncLibrary,
    LiveEffectCard,
    SceneCard,
    ContactFloat,
    FuncTwoCard,
    SliderBanner,
    Footer
  },
  data() {
    return {
      cardData: [
        {
          title: '边播边卖，导购在线推荐',
          subTitle: '导购/主播在线演示增强体验感和温度感，OMG式销货，狂增转化',
          img: require('@/assets/images/index/live-video/img2.png')
        },
        {
          title: '一键下单，加速购买决策',
          subTitle: '内嵌商城无需跳转，直达购物场景，避免客户流失',
          img: require('@/assets/images/index/live-video/img3.png')
        }
      ],
      funcData: [
        {
          title: '秒杀活动',
          subTitle: '秒杀活动是基于商品的促销工具，不仅仅会在短时间内将商品销售完，还会短时间内获得巨大流量，活动开始后自动展示促销价，结束恢复原价。是推新品和爆品的有力工具，可以快速有效地提升商品的订单转化率。',
          carouseImg: require('@/assets/images/index/mall/banner1.png')
        },
        {
          title: '优惠券营销',
          subTitle: '千人千面、智能发券，活动转化效果佳；根据不同顾客特性、营销节点、活动场景智能发放优惠券,保证优惠券使用率,「优惠」+「精准」双招促转化，顾客更爱买，帮助商家获客拉新,下单转化,提高客单,留存复购',
          carouseImg: require('@/assets/images/index/mall/banner2.png')
        },
        {
          title: '可视化自定义编辑',
          subTitle: '可视化自定义编辑平台，页面装修随心DIY！智莺系统采用可视化模板设计方式，让首页、导航、楼层、广告位、专题、商家店铺以及移动端可以根据自己网站的需求随意变动装修；系统自带多套首页模板，为运营者个性化设计自己的商城提供了更多的选择。',
          carouseImg: require('@/assets/images/index/mall/banner3.png')
        }
      ],
      stepInfo: {
        title: '领先的会员分润体系',
        subTitle: '平台可以自由设定会员等级、晋升条件、分成比例，而且可以针对不同等级的用户开放个性化功能精细化运营，让更多人帮你裂变',
        stepList: [
          {
            normalImg: require('@/assets/images/index/mall/img4.png'),
            choiceImg: require('@/assets/images/index/mall/img1.png'),
            stepTitle: '会员管理',
            showImg: require('@/assets/images/index/mall/show1.png')
          },
          {
            normalImg: require('@/assets/images/index/mall/img2.png'),
            choiceImg: require('@/assets/images/index/mall/img5.png'),
            stepTitle: '等级管理',
            showImg: require('@/assets/images/index/mall/show2.png')
          },
          {
            normalImg: require('@/assets/images/index/mall/img3.png'),
            choiceImg: require('@/assets/images/index/mall/img6.png'),
            stepTitle: '标签管理',
            showImg: require('@/assets/images/index/mall/show3.png')
          }
        ]
      },
      slider: {
        image: require('@/assets/images/index/live-video/phone.png'),
        title: '直播短视频',
        desc: "边播边卖、沉浸式购物，流量高效变现"
      },
      funInfo: {
        title: '',
        list: [
          {
            title: '多人拼团',
            img: require('@/assets/images/index/mall/img7.png'),
            text: '引导客户邀请好友一起购买，为你带来源源不断的订单和客户，只需四步拼团就可引发裂变传播，带来新客订单，还有多种功能组合，满足每一种经营场景'
          },
          {
            title: '积分营销',
            img: require('@/assets/images/index/mall/img8.png'),
            text: '商家建立积分商城系统，用户通过完成商家自主设置的积分行为，获取一定的积分，进而通过所得积分进行兑换、消费交易，消费后再获得积分奖励，往复循环中形成盘活会员用户的闭环。商家以新颖的积分营销玩法，培养用户行为习惯，提高二次营销率。'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
